import { XYZ, TileWMS, Vector as VectorSource } from 'ol/source';
import GeoJSON from 'ol/format/GeoJSON';
import { inoutflowStyle } from '../../common/data/inoutflowStyle';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';

const GISSERVER_URL = process.env.REACT_APP_GISSERVER_URL;

const inflowLayers = {
	centralHubT: new TileLayer({
		title: '유입중심거점',
		visible: true,
		opacity: 0.5,
		maxZoom: 9,
		zIndex: 1,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_pc_grid_in',
				LAYERS: 'pinogio:flow_pc_grid_2021',
			},
			crossOrigin: 'anonymous',
		}),
	}),
	centralHubV: new VectorLayer({
		title: '유입 중심거점',
		visible: true,
		opacity: 0.5,
		minZoom: 9,
		zIndex: 1,
		source: new VectorSource({ format: new GeoJSON() }),
		style: inoutflowStyle.inCentralHub,
	}),
	bgSidoLayer: new TileLayer({
		title: '시도 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_sido_sim_202112',
			},
		}),
		visible: false,
	}),
	bgSggLayer: new TileLayer({
		title: '시군구 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_sigungu_sim_202112',
			},
		}),
		visible: true,
	}),
	bgEmdLayer: new TileLayer({
		title: '읍면동 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_dong_sim_202112',
			},
		}),
		visible: false,
	}),
};

const outflowLayers = {
	centralHubT: new TileLayer({
		title: '출입중심거점',
		visible: true,
		opacity: 0.5,
		maxZoom: 11,
		zIndex: 1,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_pc_grid_out',
				LAYERS: 'pinogio:flow_pc_grid_2021',
			},
			crossOrigin: 'anonymous',
		}),
	}),
	centralHubV: new VectorLayer({
		title: '출입 중심거점',
		visible: true,
		opacity: 0.5,
		minZoom: 11,
		zIndex: 1,
		source: new VectorSource({ format: new GeoJSON() }),
		style: inoutflowStyle.outCentralHub,
	}),
	bgSidoLayer: new TileLayer({
		title: '시도 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_sido_sim_202112',
			},
		}),
		visible: false,
	}),
	bgSggLayer: new TileLayer({
		title: '시군구 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_sigungu_sim_202112',
			},
		}),
		visible: true,
	}),
	bgEmdLayer: new TileLayer({
		title: '읍면동 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_dong_sim_202112',
			},
		}),
		visible: false,
	}),
};

const inoutflowLayers = {
	centralHubT: new TileLayer({
		title: '유출입중심거점',
		visible: true,
		opacity: 0.5,
		maxZoom: 11,
		zIndex: 1,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_pc_grid_inout',
				LAYERS: 'pinogio:flow_pc_grid_2021',
			},
			crossOrigin: 'anonymous',
		}),
	}),
	centralHubV: new VectorLayer({
		title: '유출입 중심거점',
		visible: true,
		opacity: 0.5,
		minZoom: 11,
		maxZoom: 20,
		zIndex: 1,
		source: new VectorSource({ format: new GeoJSON() }),
		style: inoutflowStyle.inoutCentralHub,
	}),
	bgSidoLayer: new TileLayer({
		title: '시도 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_sido_sim_202112',
			},
		}),
		visible: false,
	}),
	bgSggLayer: new TileLayer({
		title: '시군구 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'true',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_sigungu_sim_202112',
			},
		}),
		visible: true,
	}),
	bgEmdLayer: new TileLayer({
		title: '읍면동 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				STYLES: 'flow_sido_boundary_white',
				LAYERS: 'pinogio:bnd_dong_sim_202112',
			},
		}),
		visible: false,
	}),
};

const inflowBgLayers = {
	bgLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 일반',
			url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgGrayLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 백지도',
			url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgMidNightLayer: new TileLayer({
		// visible: false,
		source: new XYZ({
			title: '브이월드 야간',
			url: 'https://xdworld.vworld.kr/2d/midnight/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgSatelliteLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 위성',
			url: 'https://xdworld.vworld.kr/2d/Satellite/service/{z}/{x}/{y}.jpeg',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
}

const outflowBgLayers = {
	bgLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 일반',
			url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgGrayLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 백지도',
			url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgMidNightLayer: new TileLayer({
		// visible: false,
		source: new XYZ({
			title: '브이월드 야간',
			url: 'https://xdworld.vworld.kr/2d/midnight/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgSatelliteLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 위성',
			url: 'https://xdworld.vworld.kr/2d/Satellite/service/{z}/{x}/{y}.jpeg',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
}

const inoutflowBgLayers = {
	bgLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 일반',
			url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgGrayLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 백지도',
			url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgMidNightLayer: new TileLayer({
		// visible: false,
		source: new XYZ({
			title: '브이월드 야간',
			url: 'https://xdworld.vworld.kr/2d/midnight/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgSatelliteLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 위성',
			url: 'https://xdworld.vworld.kr/2d/Satellite/service/{z}/{x}/{y}.jpeg',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
}

const bgMapObject = {
	basic: 'bgLayer',
	white: 'bgGrayLayer',
	midNight: 'bgMidNightLayer',
	satellite: 'bgSatelliteLayer',
};

export {
	inflowLayers,
  outflowLayers,
  inoutflowLayers,
	inflowBgLayers,
	outflowBgLayers,
	inoutflowBgLayers,
	bgMapObject,
};
